<template>
<div class="status tw-flex tw-flex-col tw-items-center type-client lg:tw-pb-0 tw-pb-8 lg:tw-pt-20">
    <title-section
    title="Estado vivienda"
    subtitle="¿En qué condiciones se encuentra tu vivienda?"></title-section>

    <div class="mdc-chip-set mdc-chip-set--choice justify-center tw-mt-8 tw-flex tw-flex-col">
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('excelente')}" @click="selectChip('excelente')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <div class="tw-flex tw-flex-col">
                <span class="tw-mb-6 tw-font-bold">Excelente</span>
                <span class="optional tw-leading-8">La vivienda es de obra nueva o ha sido reformada recientemente con acabados de alta calidad</span>
            </div>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('muy-buena')}" @click="selectChip('muy-buena')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <div class="tw-flex tw-flex-col">
                <span class=" tw-mb-6 tw-font-bold">Muy buena</span>
                <span class="optional tw-leading-8 ">La vivienda ha sido reformada en la última década, su estado es óptimo</span>
            </div>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div> 
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('buena')}" @click="selectChip('buena')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <div class="tw-flex tw-flex-col">
                <span class=" tw-mb-6 tw-font-bold">Buena</span>
                <span class="optional tw-leading-8 ">La vivienda no ha sido reformada a corto plazo y tiene algo de desgaste material</span>
            </div>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('mala')}" @click="selectChip('mala')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <div class="tw-flex tw-flex-col">
                <span class=" tw-mb-6 tw-font-bold">Mala</span>
                <span class=" optional tw-leading-8">La vivienda es antigua y tiene un deterioro notable</span>
            </div>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
    </div>
</div>
</template>

<script>
import { initiateChips } from "../../utils";
import { mapMutations, mapGetters } from "vuex";
export default {
computed: {
    ...mapGetters({
        wizard: 'getWizard'
    })
},
methods: {
    ...mapMutations(["selectState"]),
    selectChip(chip) {
        this.selectState(chip);
        this.$router.push({ name: "SaleState" });
    },
    isSelected(chip){
        return chip === this.wizard.state;
    }
},
mounted() {
    initiateChips();
}
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
.status {
        .mdc-chip {
        width: 100% !important;
        height: 100%;
        padding: 4rem;
        justify-content: flex-start !important;
    }
}
</style>
  